<template>
    <div class="product-book-container__block">
        <div class="c-product-info-block">
            <a class="c-product-info-block__image" :href="item.url">
                <webp-picture :webp="item.thumbnail_webp_path" class="border flex-center">
                    <img class="" :src="item.thumbnail_path" alt="">
                </webp-picture>
            </a>

            <div class="c-product-info-block__detail">
                <div class="c-product-info-block__title u-text-ellipsis has-2-lines">
                    <div class="u-text-ellipsis has-2-lines">
                        <a :href="item.url">{{ item.item_title }}</a>
                    </div>
                </div>
                <div v-if="item.talents.length > 0" class="c-product-info-block__name">
                    <div class="u-text-ellipsis has-2-lines" data-talents="check">
                        <a v-for="(talent, i) in item.talents" :key="`first-${i}`"
                        :href="route(route_list, 'site.talent.detail', {model_id: talent.id, model_name: talent.name})">
                           {{ talent.name }}
                        </a>
                    </div>
                </div>
                <div v-else-if="item.is_media_do_contents && item.mediado_model_names" class="c-product-info-block__name">
                    <div class="u-text-ellipsis has-2-lines">
                        <a v-for="(talent, i) in item.mediado_model_names.split(',')" :key="`first-${i}`"
                        tabindex="-1" style="pointer-events:none">
                           {{ talent }}
                        </a>
                    </div>
                </div>
                <div class="c-product-info-block__labels">
                    <div class="c-label is-new u-mb-0" v-if="item.is_new == true">New</div>
                    <div class="c-label is-photos u-mb-0">{{ item.category }}</div>
                    <div class="c-label is-limited u-mb-0" v-if="item.with_extra == true">限定特典付</div>
                </div>
                <div class="c-product-info-block__price">
                    <!-- 定価 -->
                    <div class="c-price-and-tax is-subtle" :class="{'is-crossed': item.is_campaign || (is_plus && !item.is_media_do_contents)}">
                        <span class="c-price_value">￥{{ item.current_tax_base_price }}</span><span class="c-price_tax">（税込）</span>
                    </div>
                    <div class="c-product-info-block__discount">
                        <div v-if="item.is_campaign">
                            <!-- 割引 -->
                            <div class="c-product-info-block__discount-type is-pink u-mb-2">セール価格</div>
                            <div class="c-product-info-block__discount-price">
                                <div class="c-price-and-tax is-pink" :class="{'is-crossed': item.is_plus_discount && !item.is_media_do_contents}">
                                    <span class="c-price_value">￥{{ item.current_sales_tax_price }}</span><span class="c-price_tax">（税込）</span>
                                </div>
                                <div class="c-label has-wide-padding is-pink">{{ item.discount_string }}OFF</div>
                            </div>
                        </div>
                        <div v-if="!item.is_media_do_contents">
                            <div class="c-product-info-block__discount-type u-mb-2">週プレ プラス！会員価格</div>
                            <div class="c-product-info-block__discount-price">
                                <div class="c-price-and-tax is-orange">
                                    <span class="c-price_value">￥{{ item.is_plus_discount ? item.current_tax_price : item.current_tax_plus_price }}</span><span class="c-price_tax">（税込）</span>
                                </div>
                                <div v-if="parseInt(item.current_tax_price)" class="c-label has-wide-padding is-orange">{{ item.total_discount_string }}OFF</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="c-product-info-block__buttons">
                <template v-if="item.bookend_download_id">
                    <a href="javascript:void(0)" :data-bookid="item.bookend_download_id"
                       class="js-book-read-button app-read-btn c-round-btn is-positive is-transparent">
                       アプリで見る
                    </a>
                    <a v-if="item.can_use_browser_viewer"
                       class="c-round-btn is-positive"
                       :href="route(route_list, 'site.item.viewer', {item_detail_url: item.ITEM_DETAIL_URL})"
                       target="_blank">
                       ブラウザで見る
                    </a>
                </template>
                <template v-else-if="item.is_pre_order && !item.is_pre_order_end">
                    <div class="c-label is-reservation u-mb-5">予約受付中</div>
                    <a class="c-round-btn is-positive"
                       :href="item.pre_order_url">
                       予約をする
                    </a>
                </template>
                <template v-else-if="item.is_sale_started !== false">
                    <a v-if="!item.in_cart"
                       class="c-round-btn is-positive"
                       :href="route(route_list, 'site.cart.add', {id: item.ITEM_DETAIL_URL})">
                       買い物かごに追加
                    </a>
                    <a v-else
                       class="c-round-btn is-positive"
                       :href="route(route_list, 'site.cart')">
                       買い物かごを見る
                    </a>
                    <a v-if="item.web_free_url != null"
                       class="c-round-btn is-positive is-transparent"
                       :href="item.web_free_url"
                       target="_blank">
                       立ち読み
                    </a>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    import routeMixin from '../../mixins/route.js';
    import moment from 'moment';

    export default {
        props: [
            'route_list',
            'item',
            'is_plus',
        ],
        mixins: [routeMixin],
        data() {
            return {
            }
        },
        computed: {
            moment: function (date) {
                return moment(date).format('YYYY/MM/DD');
            }
        },
        methods: {
            // 商品価格を3桁区切り
            formatPrice(price) {
                const formatter = new Intl.NumberFormat('ja-JP');
                return formatter.format(price);
            },
        },

    }
</script>

<style lang="scss" scoped>
picture {
    width: 95%;
    aspect-ratio: 148 / 209;
    object-fit: contain;
    object-position: top;
    border: 1px solid var(--gj-border-color);

    img {
        width: 100%;
    }
}
.c-product-info-block {
    color: var(--gj-text-color);
    width: 100%;
    display: grid;
    grid-template-columns: 148px 1fr;
    grid-template-rows: 1fr min-content;
    gap: 16px 16px;
    grid-template-areas:
        "image detail"
        "buttons buttons";

    .c-product-info-block__image {
        position: relative;
        grid-area: image;
        display: flex;
        justify-content: flex-end;

        .c-product-info-block__cover {
            width: 95%;
            aspect-ratio: 148 / 209;
            object-fit: contain;
            border: 1px solid var(--gj-border-color);
        }
    }
    .c-product-info-block__detail {
        grid-area: detail;
        display: grid;
        grid-template-rows: repeat(4, min-content);
        grid-template-areas:
            "title"
            "name"
            "labels"
            "price";
        row-gap: 4px;
    }

    .c-product-info-block__buttons {
        grid-area: buttons;
        display: flex;
        gap: 8px;

        & > * {
            flex: 1;
            font-size: 10px;
        }
    }

    .c-product-info-block__title,
    .c-product-info-block__name {
        font-weight: 600;
        display: flex;
    }

    .c-product-info-block__title {
        grid-area: title;
        font-size: 20px;
        line-height: 135%;
        min-height: 54px;
        align-items: start;
        word-break: break-all;
        overflow: hidden;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        display: -webkit-box;
    }

    .c-product-info-block__name {
        grid-area: name;
        font-size: 14px;
        line-height: 130%;
        min-height: 36px;
        align-items: center;
    }
    .c-product-info-block__labels {
        grid-area: labels;
    }

    .c-product-info-block__price {
        grid-area: price;
        display: flex;
        gap: 12px;
        flex-direction: column;
    }
    .c-product-info-block__discount {
        display: flex;
        gap: 12px;
        flex-direction: column;
    }

    .c-product-info-block__discount-type {
        font-size: 11px;
        font-weight: 600;
        line-height: 130%;

        &.is-pink {
            color: var(--gj-color-pink);
        }
    }
    .c-product-info-block__discount-price {
        display: flex;
        align-items: flex-start;
    }
}

@media (min-width: 768px) {
    .c-product-info-block {
        grid-template-columns: 117px 1fr 210px;
        grid-template-rows: 1fr;
        grid-template-areas: "image detail buttons";

        .c-product-info-block__discount {
            flex-direction: row;
        }

        .c-product-info-block__buttons {
            flex-direction: column;
            justify-content: flex-end;
            & > * {
                flex: 0;
                font-size: 13px;
            }
        }
    }

    .is-tile .c-product-info-block {
        grid-template-columns: 1fr;
        grid-template-rows: repeat(3, min-content);
        row-gap: 7px;
        grid-template-areas:
            "image"
            "detail"
            "buttons";

        .c-product-info-block__detail {
            row-gap: 8px;
            grid-template-areas:
                "labels"
                "title"
                "name"
                "price";
        }

        .c-product-info-block__title {
            font-size: 13px;
            font-style: normal;
            font-weight: 300;
            line-height: 130%;
            color: var(--gj-text-color-light);
            min-height: 34px;
            word-break: break-all;
            overflow: hidden;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            display: -webkit-box;
        }

        .c-product-info-block__image {
            .c-product-info-block__cover {
                aspect-ratio: 238 / 337;
            }
        }

        .c-product-info-block__discount {
            flex-direction: column;
            gap: 8px;
            min-height: 92px;
        }

        .c-product-info-block__buttons {
            margin-top: 9px;
        }
    }
}
</style>
